import { render, staticRenderFns } from "./testResponseModal.vue?vue&type=template&id=345ffb54&scoped=true&"
import script from "./testResponseModal.vue?vue&type=script&lang=js&"
export * from "./testResponseModal.vue?vue&type=script&lang=js&"
import style0 from "./testResponseModal.vue?vue&type=style&index=0&id=345ffb54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345ffb54",
  null
  
)

export default component.exports